// extracted by mini-css-extract-plugin
module.exports = {"container":"Uploadly_container__19kG-","dropZone":"Uploadly_dropZone__fac-Z"};